import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { DataTableDirective } from 'angular-datatables';
import { DistributorFilter } from '../../models/distributor-filter';
import { HttpClient } from '@angular/common/http';
import { BusAuctionFilterService } from '../../services/bus-auction-filter.service';
import { ContractorBaseFilter } from '../../models/contractor-base-filter';
import { ContractorBaseAuction } from '../../models/contractor-base-auction';
import { LoggingService } from '../../../../services/logging.service';

const apiServer = environment.apiServer;
declare var $: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: 'app-home-main-modal-detail-base',
  templateUrl: './home-main-modal-detail-base.component.html',
  styleUrls: ['./home-main-modal-detail-base.component.sass']
})
export class HomeMainModalDetailBaseComponent implements OnInit, AfterViewInit {


  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  dt: DataTables.Api;
  modelContractorBaseFilter: ContractorBaseFilter = new ContractorBaseFilter();
  modelContractorBaseAuction: ContractorBaseAuction = new ContractorBaseAuction();
  dtOptionsContractor: DataTables.Settings = {};
  dataSetContractors: any;
  private opened = false;

  constructor(private http: HttpClient, private bus: BusAuctionFilterService, private loggingService: LoggingService, private cd: ChangeDetectorRef) { }

  ngOnInit() {

    const that = this;
    
    $('#modalDetailAuctionBase').off('shown.bs.modal').on('shown.bs.modal', function () {
      if (!that.opened) {
        that.opened = true;
        that.dt.ajax.reload();
      }
    });

    this.dtOptionsContractor = {
      pagingType: 'full_numbers',
      pageLength: 250,
      serverSide: true,
      processing: true,
      autoWidth: false,
      dom: 'tip',
      order: [1],
      deferLoading: 0,
      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {

        dataTablesParameters.ContractName = this.modelContractorBaseFilter.name;

        that.http.post<DataTablesResponse>(`${apiServer}/contract`, dataTablesParameters, {})
          .subscribe(resp => {
            that.dataSetContractors = resp.data;
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
            that.cd.detectChanges();
          });
      },
      columns: [
        { orderable: false },
        { data: 'primaryContractName', name: 'primaryContractName' },
      ]
    };
  }

  onFieldChange() {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalDetailBaseComponent.onFieldChange', null, 'Field change started');
      
      this.dt.ajax.reload();
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalDetailBaseComponent.onFieldChange', null, 'Field change completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalDetailBaseComponent.onFieldChange', _error, null, 'Field change failed');
      throw _error;
    }
  }


  onSelectContract(contract: string): void {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalDetailBaseComponent.onSelectContract', null, 'Select contract started');
      
      this.modelContractorBaseAuction.contractName = contract;
      this.bus.changeContractBaseAuction(this.modelContractorBaseAuction);
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalDetailBaseComponent.onSelectContract', null, 'Select contract completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalDetailBaseComponent.onSelectContract', _error, null, 'Select contract failed');
      throw _error;
    }
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-detail-base/home-main-modal-detail-base.component.ts